import { render, staticRenderFns } from "./Rvs3dTimeWaveFormGraph.vue?vue&type=template&id=3c06fb0c&scoped=true"
import script from "./Rvs3dTimeWaveFormGraph.vue?vue&type=script&lang=ts"
export * from "./Rvs3dTimeWaveFormGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06fb0c",
  null
  
)

export default component.exports